import { INSTANCE_NAMES, getInstance, setInstance } from '@retail/single-instance-cache';

import { RemainingLimitsCollection } from './RemainingLimitsCollection';

export function getRemainingLimits() {
    let remainingLimits = getInstance<RemainingLimitsCollection>(
        INSTANCE_NAMES.REMAINING_LIMITS_COLLECTION,
    );

    if (!remainingLimits) {
        remainingLimits = new RemainingLimitsCollection();
        setInstance(INSTANCE_NAMES.REMAINING_LIMITS_COLLECTION, remainingLimits);
    }

    return remainingLimits;
}
